import PerfectScrollbar from "react-perfect-scrollbar";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { toggleSidebar } from "../../store/themeConfigSlice";
import AnimateHeight from "react-animate-height";
import { useState, useEffect } from "react";
import IconCaretsDown from "../Icon/IconCaretsDown";
import IconCaretDown from "../Icon/IconCaretDown";
import IconMenuDashboard from "../Icon/Menu/IconMenuDashboard";
import IconMinus from "../Icon/IconMinus";
import IconSettings from "../Icon/IconSettings";
import IconListCheck from "../Icon/IconListCheck";
import IconUsersGroup from "../Icon/IconUsersGroup";
import IconDesktop from "../Icon/IconDesktop";
import IconMenuCalendar from "../Icon/Menu/IconMenuCalendar";
import IconMenuContacts from "../Icon/Menu/IconMenuContacts";
import IconMenuInvoice from "../Icon/Menu/IconMenuInvoice";
import IconSquareCheck from "../Icon/IconSquareCheck";
import IconUserPlus from "../Icon/IconUserPlus";
import IconMenuComponents from "../Icon/Menu/IconMenuComponents";
import IconMenuElements from "../Icon/Menu/IconMenuElements";
import IconMenuCharts from "../Icon/Menu/IconMenuCharts";
import IconMenuWidgets from "../Icon/Menu/IconMenuWidgets";
import IconMenuFontIcons from "../Icon/Menu/IconMenuFontIcons";
import IconMenuDragAndDrop from "../Icon/Menu/IconMenuDragAndDrop";
import IconMenuTables from "../Icon/Menu/IconMenuTables";
import IconMenuDatatables from "../Icon/Menu/IconMenuDatatables";
import IconMenuForms from "../Icon/Menu/IconMenuForms";
import IconMenuUsers from "../Icon/Menu/IconMenuUsers";
import IconMenuPages from "../Icon/Menu/IconMenuPages";
import IconMenuAuthentication from "../Icon/Menu/IconMenuAuthentication";
import IconMenuDocumentation from "../Icon/Menu/IconMenuDocumentation";
import IconMenuMore from "../Icon/Menu/IconMenuMore";

const Sidebar = () => {
  const [currentMenu, setCurrentMenu] = useState("");
  const [errorSubMenu, setErrorSubMenu] = useState(false);
  const themeConfig = useSelector((state) => state.themeConfig);
  const semidark = useSelector((state) => state.themeConfig.semidark);
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const toggleMenu = (value) => {
    setCurrentMenu((oldValue) => {
      return oldValue === value ? "" : value;
    });
  };

  useEffect(() => {
    const selector = document.querySelector(
      '.sidebar ul a[href="' + window.location.pathname + '"]'
    );
    if (selector) {
      selector.classList.add("active");
      const ul = selector.closest("ul.sub-menu");
      if (ul) {
        let ele = ul.closest("li.menu").querySelectorAll(".nav-link") || [];
        if (ele.length) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      }
    }
  }, []);

  useEffect(() => {
    if (window.innerWidth < 1024 && themeConfig.sidebar) {
      dispatch(toggleSidebar());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div className={semidark ? "dark" : ""}>
      <nav
        className={`sidebar fixed min-h-screen h-full top-0 bottom-0 w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] z-50 transition-all duration-300 ${
          semidark ? "text-white-dark" : ""
        }`}
      >
        <div className="bg-white dark:bg-black h-full">
          <div className="flex justify-between items-center px-4 py-3">
            <NavLink to="/" className="main-logo flex items-center shrink-0">
              <img
                className="w-8 ml-[5px] flex-none"
                src="/assets/images/logo.svg"
                alt="logo"
              />
              <span className="text-2xl ltr:ml-1.5 rtl:mr-1.5 font-semibold align-middle lg:inline dark:text-white-light">
                {t("EPR")}
              </span>
            </NavLink>

            <button
              type="button"
              className="collapse-icon w-8 h-8 rounded-full flex items-center hover:bg-gray-500/10 dark:hover:bg-dark-light/10 dark:text-white-light transition duration-300 rtl:rotate-180"
              onClick={() => dispatch(toggleSidebar())}
            >
              <IconCaretsDown className="m-auto rotate-90" />
            </button>
          </div>
          <PerfectScrollbar className="h-[calc(100vh-80px)] relative">
            <ul className="relative font-semibold space-y-0.5 p-4 py-0">
              <li className="menu nav-item">
                <button
                  type="button"
                  className={`${
                    currentMenu === "dashboard" ? "active" : ""
                  } nav-link group w-full`}
                  onClick={() => toggleMenu("dashboard")}
                >
                  <div className="flex items-center">
                    <IconMenuDashboard className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("SETUP")}
                    </span>
                  </div>

                  <div
                    className={
                      currentMenu !== "dashboard"
                        ? "rtl:rotate-90 -rotate-90"
                        : ""
                    }
                  >
                    <IconCaretDown />
                  </div>
                </button>

                <AnimateHeight
                  duration={300}
                  height={currentMenu === "dashboard" ? "auto" : 0}
                >
                  <ul className="sub-menu text-gray-500">
                    <li>
                      <NavLink to="/">{t("Client")}</NavLink>
                    </li>
                    <li>
                      <NavLink to="/Location">{t("Location")}</NavLink>
                    </li>
                    <li>
                      <NavLink to="/Division">{t("Division")}</NavLink>
                    </li>
                    <li>
                      <NavLink to="/Scope">{t("Scope")}</NavLink>
                    </li>
                  </ul>
                </AnimateHeight>
              </li>

              <h2 className="py-3 px-7 flex items-center uppercase font-extrabold bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08] -mx-4 mb-1">
                <IconMinus className="w-4 h-5 flex-none hidden" />
                <span>{t("USER")}</span>
              </h2>

              <li className="nav-item">
                <ul>
                  <li className="nav-item">
                    <NavLink to="../../pages/Sample" className="group">
                      <div className="flex items-center">
                        <IconUserPlus className="group-hover:!text-primary shrink-0" />
                        <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                          {t("User Management")}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="../../pages/Sample1" className="group">
                      <div className="flex items-center">
                        <IconSquareCheck className="group-hover:!text-primary shrink-0" />
                        <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                          {t("Role")}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="../../pages/Sample2" className="group">
                      <div className="flex items-center">
                        <IconListCheck className="group-hover:!text-primary shrink-0" />
                        <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                          {t("Menu Access")}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="../../pages/Sample3" className="group">
                      <div className="flex items-center">
                        <IconUsersGroup className="group-hover:!text-primary shrink-0" />
                        <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                          {t("Teams")}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink to="../../pages/Sample4" className="group">
                      <div className="flex items-center">
                        <IconSettings className="group-hover:!text-primary shrink-0" />
                        <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                          {t("Employee Listing")}
                        </span>
                      </div>
                    </NavLink>
                  </li>
                </ul>
              </li>

              <h2 className="py-3 px-7 flex items-center uppercase font-extrabold bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08] -mx-4 mb-1">
                <IconMinus className="w-4 h-5 flex-none hidden" />
                <span>{t("PRODUCTION")}</span>
              </h2>

              <li className="menu nav-item">
                <NavLink to="/Production/ProductionTemplate" className="group">
                  <div className="flex items-center">
                    <IconMenuCharts className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Production Template")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="/production/allocationTemplate" className="group">
                  <div className="flex items-center">
                    <IconMenuWidgets className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Allocation Template")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/allocReAlloc" className="group">
                  <div className="flex items-center">
                    <IconMenuFontIcons className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Allocation & ReAllocation")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="/Production/InventoryMgmt" className="group">
                  <div className="flex items-center">
                    <IconMenuDragAndDrop className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Inventory Management")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/allocatedFiles" className="group">
                  <div className="flex items-center">
                    <IconMenuDocumentation className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Allocated Files")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/coachingFeedback" className="group">
                  <div className="flex items-center">
                    <IconDesktop className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Coaching & Feedbacks")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/searchFileLogs" className="group">
                  <div className="flex items-center">
                    <IconMenuContacts className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Search File Logs")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/rampTarget" className="group">
                  <div className="flex items-center">
                    <IconMenuCalendar className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Ramp Target")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/masters" className="group">
                  <div className="flex items-center">
                    <IconMenuPages className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Masters")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <li className="menu nav-item">
                <NavLink to="production/reports" className="group">
                  <div className="flex items-center">
                    <IconMenuForms className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("Reports")}
                    </span>
                  </div>
                </NavLink>
              </li>

              <h2 className="py-3 px-7 flex items-center uppercase font-extrabold bg-white-light/30 dark:bg-dark dark:bg-opacity-[0.08] -mx-4 mb-1">
                <IconMinus className="w-4 h-5 flex-none hidden" />
                <span>{t("supports")}</span>
              </h2>

              <li className="menu nav-item">
                <NavLink
                  to="https://vristo.sbthemes.com"
                  target="_blank"
                  className="nav-link group"
                >
                  <div className="flex items-center">
                    <IconMenuDocumentation className="group-hover:!text-primary shrink-0" />
                    <span className="ltr:pl-3 rtl:pr-3 text-black dark:text-[#506690] dark:group-hover:text-white-dark">
                      {t("documentation")}
                    </span>
                  </div>
                </NavLink>
              </li>
            </ul>
          </PerfectScrollbar>
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
